import api, { type QrPosition } from '@meno/ui/lib/api'

// Shared Interactive-Link loader. The /menus endpoint is shared with the
// (currently stubbed) menu UI, so we filter for type='interactive' to get
// just the Asset → Links rows. The shape returned matches the LinkItem the
// PlaylistDialog / picker consume.
export type LinkItem = {
  id: number
  name: string
  interactive_link: string
  show_qr: boolean
  qr_position: QrPosition
}

export async function loadLinks(): Promise<LinkItem[]> {
  const r = await api.get('/menus')
  return (r.data as any[])
    .filter(m => m.type === 'interactive')
    .map(m => ({
      id: m.id,
      name: m.name,
      interactive_link: m.interactive_link ?? '',
      show_qr: !!m.show_qr,
      qr_position: (m.qr_position as QrPosition) ?? 'bottom-right',
    }))
}
